/*
  CURBi contact form — reveals the adverse-event notice.

  The notice is rendered VISIBLE in curbi-contact-form.liquid and hidden here,
  on load. That order matters: with JavaScript off the reader still sees 000,
  the Poisons Information Centre and the TGA link. Never move the hiding into
  the markup.
*/
(function () {
  function init(select) {
    if (select.dataset.curbiContactBound === 'true') return;
    select.dataset.curbiContactBound = 'true';

    var form = select.closest('form');
    if (!form) return;

    var notice = form.querySelector('[data-curbi-contact-adverse]');
    if (!notice) return;

    // The value that reveals the notice is a theme setting, so it travels with
    // the copy rather than being pinned here.
    var trigger = (select.dataset.adverseValue || '').trim();

    function sync() {
      var open = trigger !== '' && select.value.trim() === trigger;
      notice.hidden = !open;
    }

    select.addEventListener('change', sync);
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-curbi-contact-enquiry]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section; the guard above keeps this idempotent.
  document.addEventListener('shopify:section:load', initAll);
})();
